import {
  UPDATE_NOTE_LIST,
  UPDATE_DELETENOTE_LIST,
  RESET_NOTE_LIST,
  RESET_DELETENOTE_LIST,
  ADD_TOTAL,
  REDUCE_TOTAL,
  RESET_TOTAL,
  UPDATE_POSTDAY_LIST,
  RESET_POSTDAY_LIST,
  RESET_FOLLOW_NOTE_LIST,
  UPDATE_FOLLOW_NOTE_LIST,
  UPDATE_NOTIFICATION_LIST,
  RESET_NOTIFICATION_LIST,
  PIN_NOTIFICATION_LIST,
  SET_EHD_SETTING
} from '../../constant';

const UpDateFollowNoteList = (taskId) => ({
  type: UPDATE_FOLLOW_NOTE_LIST,
  data: { taskId },
});

const ResetFollowNoteList = () => ({
  type: RESET_FOLLOW_NOTE_LIST,
});

const UpDateNoteList = (taskId) => ({
  type: UPDATE_NOTE_LIST,
  data: { taskId },
});

const ResetNoteList = () => ({
  type: RESET_NOTE_LIST,
});

const UpDateDeleteNoteList = (deletetaskId) => ({
  type: UPDATE_DELETENOTE_LIST,
  data: { deletetaskId },
});

const ResetDeleteNoteList = () => ({
  type: RESET_DELETENOTE_LIST,
});

const UpDatePostDayNoteList = (taskId) => ({
  type: UPDATE_POSTDAY_LIST,
  data: { taskId },
});

const ResetPostDayNoteList = () => ({
  type: RESET_POSTDAY_LIST,
});

const UpDateNotificationNoteList = (data) => ({
  type: UPDATE_NOTIFICATION_LIST,
  data,
});

const ResetNotificationNoteList = () => ({
  type: RESET_NOTIFICATION_LIST,
});

const AddTotal = (num) => ({
  type: ADD_TOTAL,
  data: { num },
});

const ReduceTotal = (num) => ({
  type: REDUCE_TOTAL,
  data: { num },
});

const ResetTotal = (total) => ({
  type: RESET_TOTAL,
  data: { total },
});

const PinNotification = (data) => ({
  type: PIN_NOTIFICATION_LIST,
  data,
});

const setEhdSetting = (data) => (
{
  type: SET_EHD_SETTING,
  data,
});

export {
  UpDateNoteList,
  UpDateDeleteNoteList,
  ResetNoteList,
  ResetDeleteNoteList,
  AddTotal,
  ReduceTotal,
  ResetTotal,
  UpDatePostDayNoteList,
  ResetPostDayNoteList,
  UpDateFollowNoteList,
  ResetFollowNoteList,
  UpDateNotificationNoteList,
  ResetNotificationNoteList,
  PinNotification,
  setEhdSetting
};
